import React from 'react';
import AngleDownRaw from 'assets/images/svg/angle-down.svg';
import CheckRaw from 'assets/images/svg/check.svg';
import CircleCheckRaw from 'assets/images/svg/circle-check.svg';
import CircleExclamationRaw from 'assets/images/svg/circle-exclamation.svg';
import WarningRaw from 'assets/images/svg/warning.svg';
import RetryRaw from 'assets/images/svg/retry.svg';
import QuestionRaw from 'assets/images/svg/question.svg';
import InfoRaw from 'assets/images/svg/info.svg';
import CancelRaw from 'assets/images/svg/cancel.svg';
import SpinnerSlowRaw from 'assets/images/svg/spinner-slow.svg';
import MultiGearRaw from 'assets/images/svg/multi-gear.svg';
import EllipsisVerticalRaw from 'assets/images/svg/ellipsis-vertical.svg';

// svg-react-loader attaches each SVG's root attributes (xmlns, viewBox, …) as the
// component's `.defaultProps`, which triggers React 18.3's "Support for defaultProps
// will be removed from function components" warning. We lift those defaults into an
// explicit wrapper and delete `defaultProps` from the underlying component so it no
// longer warns. Import each raw SVG here exactly once (ES modules are singletons), so
// the delete happens a single time and the captured defaults stay intact everywhere.
const wrap = Raw => {
	const defaults = { ...(Raw.defaultProps || {}) };
	delete Raw.defaultProps;
	const Icon = props => <Raw {...defaults} {...props} />;
	Icon.displayName = Raw.displayName || 'SvgIcon';
	return Icon;
};

export const AngleDownIcon = wrap(AngleDownRaw);
export const CheckIcon = wrap(CheckRaw);
export const CircleCheckIcon = wrap(CircleCheckRaw);
export const CircleExclamationIcon = wrap(CircleExclamationRaw);
export const WarningIcon = wrap(WarningRaw);
export const RetryIcon = wrap(RetryRaw);
export const QuestionIcon = wrap(QuestionRaw);
export const InfoIcon = wrap(InfoRaw);
export const CancelIcon = wrap(CancelRaw);
export const SpinnerSlowIcon = wrap(SpinnerSlowRaw);
export const MultiGearIcon = wrap(MultiGearRaw);
export const EllipsisVerticalIcon = wrap(EllipsisVerticalRaw);
